"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _TimePicker = _interopRequireDefault(require("@mui/lab/TimePicker"));

var _LocalizationProvider = _interopRequireDefault(require("@mui/lab/LocalizationProvider"));

var _AdapterMoment = _interopRequireDefault(require("@mui/lab/AdapterMoment"));

var _CalendarSetting = require("./CalendarSetting.shape");

var CalendarSettingDayTime = function CalendarSettingDayTime(_ref) {
  var slot = _ref.slot,
      isRemovable = _ref.isRemovable,
      showAddButton = _ref.showAddButton,
      disabled = _ref.disabled,
      onAddSlot = _ref.onAddSlot,
      onRemoveSlot = _ref.onRemoveSlot,
      onChangeSlotDate = _ref.onChangeSlotDate;
  var id = slot.id,
      day = slot.day,
      from = slot.from,
      till = slot.till,
      fromError = slot.fromError,
      tillError = slot.tillError;
  var handleRemove = (0, _react.useCallback)(function () {
    return onRemoveSlot(id, day);
  }, [onRemoveSlot, id, day]);
  var handleDateChange = (0, _react.useCallback)(function (value, type) {
    return onChangeSlotDate(id, day, type, value);
  }, [onChangeSlotDate, id, day]);
  return /*#__PURE__*/_react.default.createElement(_LocalizationProvider.default, {
    dateAdapter: _AdapterMoment.default
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "flex-start"
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 5 / 12
  }, /*#__PURE__*/_react.default.createElement(_TimePicker.default, {
    id: "time-picker-from-".concat(id),
    label: "Start time",
    value: from,
    onChange: function onChange(value) {
      return handleDateChange(value, 'from');
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react.default.createElement(_material.TextField, (0, _extends2.default)({}, params, {
        margin: "normal",
        helperText: fromError,
        error: !!fromError,
        variant: "outlined",
        fullWidth: true
      }));
    },
    disabled: disabled,
    OpenPickerButtonProps: {
      'aria-label': 'change time'
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 1 / 12,
    pt: 4,
    pl: 1,
    pr: 1,
    textAlign: "center"
  }, "to"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 5 / 12,
    mr: 1
  }, /*#__PURE__*/_react.default.createElement(_TimePicker.default, {
    id: "time-picker-till-".concat(id),
    label: "End time",
    value: till,
    onChange: function onChange(value) {
      return handleDateChange(value, 'till');
    },
    renderInput: function renderInput(params) {
      return /*#__PURE__*/_react.default.createElement(_material.TextField, (0, _extends2.default)({}, params, {
        margin: "normal",
        helperText: tillError,
        error: !!tillError,
        variant: "outlined",
        fullWidth: true
      }));
    },
    disabled: disabled,
    OpenPickerButtonProps: {
      'aria-label': 'change time2'
    }
  })), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 80,
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
    style: {
      paddingTop: 30
    },
    ml: 2
  }, isRemovable && /*#__PURE__*/_react.default.createElement(_material.Box, {
    mr: 2
  }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
    onClick: handleRemove,
    icon: "minus-circle",
    color: "error"
  })), showAddButton && /*#__PURE__*/_react.default.createElement(_material.Box, {
    mr: 2
  }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
    onClick: onAddSlot,
    icon: "plus-circle",
    color: "link.main"
  })))));
};

CalendarSettingDayTime.propTypes = {
  slot: _CalendarSetting.CalendarSlot.isRequired,
  isRemovable: _propTypes.default.bool.isRequired,
  showAddButton: _propTypes.default.bool.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  onAddSlot: _propTypes.default.func.isRequired,
  onRemoveSlot: _propTypes.default.func.isRequired,
  onChangeSlotDate: _propTypes.default.func.isRequired
};

var _default = /*#__PURE__*/(0, _react.memo)(CalendarSettingDayTime);

exports.default = _default;